import { render, staticRenderFns } from "./Attendees.vue?vue&type=template&id=53386964"
import script from "./Attendees.vue?vue&type=script&lang=js"
export * from "./Attendees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports